export const CarrierType = {
  None : 0,
  DPAG : 1,
  PIN : 2,
  Briefbutler : 3
}
